import { useEffect, useState } from "react";
import { Phone, MessageCircle, Calendar, ChevronUp } from "lucide-react";
import { BUSINESS } from "@/data/salonData";
import { openWhatsApp } from "@/lib/whatsapp";

export default function FloatingButtons() {
  const [open, setOpen] = useState(false);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="fixed bottom-5 right-4 sm:right-6 z-40 flex flex-col items-end gap-3">
        {showTop && (
          <button
            data-testid="back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fab bg-white text-[#b56477] border border-[#d98a99]/30"
            aria-label="Back to top"
          >
            <ChevronUp size={20} />
          </button>
        )}

        {/* Expanded buttons */}
        <div
          className={`flex flex-col gap-3 items-end transition-all duration-500 ${
            open
              ? "opacity-100 translate-y-0 pointer-events-auto"
              : "opacity-0 translate-y-3 pointer-events-none"
          }`}
        >
          <a
            href="#book"
            onClick={() => setOpen(false)}
            data-testid="fab-book"
            className="fab bg-gradient-to-br from-[#d4af37] to-[#b8902f]"
            aria-label="Book Appointment"
          >
            <Calendar size={22} />
          </a>
          <a
            href={`tel:${BUSINESS.phone}`}
            data-testid="fab-call"
            className="fab bg-gradient-to-br from-[#d98a99] to-[#b56477]"
            aria-label="Call us"
          >
            <Phone size={22} />
          </a>
        </div>

        {/* Main WhatsApp button (always visible) */}
        <button
          data-testid="fab-whatsapp-toggle"
          onClick={() => {
            if (open) {
              openWhatsApp(
                "Hello Anshi's Makeover! I'd like to book an appointment."
              );
            } else {
              setOpen(true);
            }
          }}
          onMouseLeave={() => setOpen(false)}
          className="fab relative bg-[#25D366] text-white pulse-ring"
          style={{ color: "#25D366" }}
          aria-label="Open WhatsApp"
        >
          <MessageCircle size={26} fill="white" className="text-white relative z-10" />
        </button>
      </div>

      {/* Persistent secondary buttons on mobile - left side */}
      <div className="fixed bottom-5 left-4 z-40 sm:hidden">
        <a
          href={`tel:${BUSINESS.phone}`}
          data-testid="fab-call-mobile"
          className="fab bg-gradient-to-br from-[#d98a99] to-[#b56477]"
          aria-label="Call us"
        >
          <Phone size={22} />
        </a>
      </div>
    </>
  );
}
